<template>
  <ClientOnly>
    <div
      v-if="show"
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-white"
      :class="{ 'fade-out-screen': startExit }"
    >
      <div class="relative flex flex-col items-center">
        <!-- Logo Container -->
        <div id="tayba-logo" class="relative overflow-hidden mb-6 p-4">
          <!-- Logo SVG -->
          <svg
            width="180"
            height="76"
            viewBox="0 0 120 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-48 md:w-64 h-auto"
          >
            <g clip-path="url(#clip0_172_1956)">
              <path
                id="Vector"
                d="M59.58 41.3398H0V42.5198H59.58V41.3398Z"
                fill="#D0A444"
              />
              <path
                id="Vector_2"
                d="M80.1794 41.1992C79.7412 41.2034 79.3137 41.3354 78.9495 41.5792C78.587 41.8239 78.272 42.1322 78.0195 42.4892V41.4192H76.6895V50.3192H78.0195V47.3192C77.9783 46.3149 78.0453 45.3091 78.2195 44.3192C78.3391 43.7973 78.6024 43.3193 78.9795 42.9392C79.2488 42.6781 79.6047 42.5251 79.9795 42.5092C80.1696 42.5234 80.3557 42.5707 80.5294 42.6492H80.5995L81.2794 41.5592H81.1895C80.8858 41.3786 80.5424 41.2755 80.1895 41.2592"
                fill="#374151"
              />
              <path
                id="Vector_3"
                d="M90.2891 47.6204C90.0024 48.129 89.5801 48.5479 89.0691 48.8304C88.5547 49.1252 87.972 49.2803 87.3791 49.2804C86.7986 49.2819 86.2285 49.1264 85.7291 48.8304C85.2173 48.5235 84.7936 48.0894 84.4991 47.5704C84.2037 47.0489 84.0485 46.4597 84.0485 45.8604C84.0485 45.261 84.2037 44.6719 84.4991 44.1504C84.7521 43.7028 85.1052 43.3199 85.5309 43.0316C85.9566 42.7433 86.4432 42.5575 86.9527 42.4887C87.4622 42.4199 87.9807 42.4701 88.4676 42.6352C88.9545 42.8003 89.3965 43.0759 89.7591 43.4404C90.0825 43.7602 90.3378 44.1421 90.5096 44.5631C90.6815 44.9842 90.7664 45.4357 90.7591 45.8904C90.7703 46.4948 90.622 47.0915 90.3291 47.6204M90.6891 42.8304C90.3164 42.3478 89.8462 41.9491 89.3091 41.6604C88.6915 41.342 88.0038 41.1839 87.3091 41.2004C86.7062 41.1931 86.1082 41.3101 85.5525 41.5441C84.9968 41.7781 84.4952 42.124 84.0791 42.5604C83.646 42.9842 83.3038 43.4919 83.0734 44.0524C82.843 44.6129 82.7293 45.2145 82.7391 45.8204C82.7275 46.4331 82.8393 47.0419 83.0678 47.6105C83.2963 48.1792 83.6368 48.696 84.0691 49.1304C84.4799 49.5681 84.9777 49.9152 85.5305 50.1494C86.0833 50.3836 86.6788 50.4998 87.2791 50.4904C87.9499 50.4951 88.6131 50.3481 89.2191 50.0604C89.7668 49.7834 90.2558 49.4031 90.6591 48.9404V50.3204H91.9491V41.4204H90.6291L90.6891 42.8304Z"
                fill="#374151"
              />
              <path
                id="Vector_4"
                d="M98.1892 47.6119L95.3692 41.4819L95.3392 41.4219H93.9492L97.9992 50.2219L98.0292 50.2719H98.3492L102.339 41.5619L102.409 41.4219H100.999L98.1892 47.6119Z"
                fill="#374151"
              />
              <path
                id="Vector_5"
                d="M105.049 44.8812C105.21 44.2632 105.535 43.7001 105.989 43.2512C106.575 42.7227 107.34 42.4368 108.129 42.4512C108.624 42.4514 109.112 42.5607 109.559 42.7712C109.983 42.9622 110.359 43.2458 110.659 43.6012C110.937 43.9867 111.141 44.4209 111.259 44.8812H105.049ZM108.109 41.2012C107.434 41.1804 106.763 41.321 106.152 41.6114C105.542 41.9019 105.009 42.3338 104.599 42.8712C103.9 43.7633 103.536 44.8726 103.571 46.0057C103.605 47.1387 104.037 48.2236 104.789 49.0712C105.211 49.5452 105.734 49.9187 106.318 50.1644C106.903 50.4102 107.536 50.5218 108.169 50.4912C108.768 50.4967 109.364 50.3986 109.929 50.2012C110.439 49.9994 110.907 49.7043 111.309 49.3312C111.76 48.9046 112.129 48.3997 112.399 47.8412V47.7512L111.309 47.1712L111.259 47.2512C111.014 47.7004 110.7 48.1086 110.329 48.4612C110.036 48.7191 109.697 48.9193 109.329 49.0512C108.93 49.2025 108.507 49.2804 108.079 49.2812C107.661 49.2894 107.246 49.21 106.86 49.0481C106.474 48.8862 106.127 48.6455 105.839 48.3412C105.247 47.7177 104.914 46.8915 104.909 46.0312H112.699V45.9312C112.718 44.8464 112.366 43.7877 111.699 42.9312C111.278 42.378 110.731 41.9333 110.103 41.6341C109.475 41.3349 108.785 41.19 108.089 41.2112"
                fill="#374151"
              />
              <path
                id="Vector_6"
                d="M68.8594 42.5802H70.6194V50.2702H71.9294V42.5802H73.6894V41.4102H68.8594V42.5802Z"
                fill="#374151"
              />
              <path
                id="Vector_7"
                d="M116.57 48.9602V41.4102H115.27V50.2702H116.14H116.57H119.03V48.9602H116.57Z"
                fill="#374151"
              />
              <path
                id="Vector_8"
                d="M7.33984 25.65C6.66505 24.9774 6.13026 24.1777 5.76637 23.2972C5.40249 22.4167 5.21673 21.4728 5.21983 20.52V13.38H12.3598V8.26001H5.21983V0L0.0898438 1.76001V20.76C0.119412 22.3922 0.480026 24.0013 1.14984 25.49C1.79691 26.9279 2.70956 28.2307 3.83984 29.33C4.96941 30.4212 6.28737 31.2987 7.72984 31.92C9.2206 32.5762 10.8311 32.9167 12.4598 32.92V27.8C11.4941 27.8034 10.5379 27.6094 9.64984 27.23C8.78866 26.8642 8.00478 26.3382 7.33984 25.68"
                fill="#D0A444"
              />
              <path
                id="Vector_9"
                d="M35.369 11.8517C34.2421 10.7331 32.9115 9.84037 31.4491 9.22171C29.9281 8.58799 28.2967 8.26172 26.649 8.26172C25.0014 8.26172 23.37 8.58799 21.8491 9.22171C18.8906 10.4641 16.536 12.8152 15.2891 15.7717C14.6317 17.2867 14.2913 18.9202 14.2891 20.5717C14.2925 22.2069 14.6329 23.8239 15.2891 25.3217C15.9076 26.7866 16.8041 28.1178 17.929 29.2417C19.0573 30.3664 20.3871 31.2688 21.8491 31.9017C23.3607 32.5697 24.9964 32.9105 26.649 32.9017C27.155 32.8969 27.6598 32.8534 28.1591 32.7717L29.6091 32.5517L28.429 27.5517L27.5591 27.7017C27.2559 27.7178 26.9522 27.7178 26.649 27.7017C25.6939 27.7067 24.7478 27.5161 23.869 27.1417C22.1432 26.3992 20.766 25.0257 20.0191 23.3017C19.645 22.4194 19.4544 21.4701 19.459 20.5117C19.4506 19.5523 19.6338 18.6008 19.9979 17.713C20.3619 16.8252 20.8995 16.0191 21.5791 15.3417C22.2357 14.6827 23.0132 14.1565 23.869 13.7917C24.7471 13.4475 25.6866 13.2876 26.6291 13.3217C27.5883 13.3185 28.5379 13.5126 29.4191 13.8917C30.2735 14.2591 31.0505 14.785 31.709 15.4417C32.3676 16.1102 32.8935 16.8974 33.2591 17.7617C33.6377 18.6641 33.8315 19.6332 33.8291 20.6117V32.9317H38.9491V20.5717C38.9468 18.9202 38.6065 17.2867 37.9491 15.7717C37.3281 14.3081 36.4318 12.9774 35.3091 11.8517"
                fill="#D0A444"
              />
              <path
                id="Vector_10"
                d="M63.36 13.0417L59.36 16.2917C59.7782 16.873 60.1146 17.509 60.36 18.1817C60.6114 18.905 60.7365 19.6661 60.73 20.4317C60.7352 21.4126 60.5341 22.3836 60.14 23.2817C59.7566 24.1484 59.2138 24.9354 58.54 25.6017C57.8589 26.2541 57.0663 26.7791 56.2 27.1517C55.2938 27.5293 54.3216 27.723 53.34 27.7217C52.3746 27.722 51.4189 27.5282 50.53 27.1517C49.6609 26.784 48.8676 26.2585 48.19 25.6017C47.5036 24.9279 46.9596 24.1231 46.5902 23.2349C46.2209 22.3468 46.0338 21.3935 46.04 20.4317C46.0091 19.2054 46.3171 17.9943 46.93 16.9317L42.84 13.7317C41.9093 15.262 41.2907 16.9613 41.02 18.7317C41.0168 18.9525 41.0001 19.1729 40.97 19.3917C40.9391 19.6305 40.9224 19.8709 40.92 20.1117V20.4617C40.9149 22.1365 41.2554 23.7944 41.92 25.3317C42.5537 26.8016 43.4596 28.1384 44.59 29.2717C45.7194 30.4042 47.0574 31.3075 48.53 31.9317C50.0527 32.5979 51.6979 32.9385 53.36 32.9317C54.6994 32.9347 56.0303 32.7185 57.3 32.2917C58.5393 31.8675 59.7037 31.2498 60.75 30.4617V35.7817C60.7543 36.8785 60.5008 37.9609 60.01 38.9417C59.524 39.9077 58.843 40.7623 58.01 41.4517V41.5417L61.8 44.9917C63.0536 43.8419 64.0518 42.4417 64.73 40.8817C65.4416 39.2763 65.8029 37.5377 65.79 35.7817V20.4317C65.8062 19.0716 65.5898 17.7188 65.15 16.4317C64.7287 15.2023 64.1144 14.0479 63.33 13.0117"
                fill="#D0A444"
              />
              <path
                id="Vector_11"
                d="M88.831 11.8603C87.7107 10.7357 86.3829 9.8391 84.921 9.22031C83.4028 8.56211 81.7658 8.22178 80.111 8.22031C79.5919 8.21735 79.0735 8.2575 78.561 8.34032C78.081 8.42032 77.611 8.50032 77.161 8.56032L78.341 13.5603C78.6165 13.4875 78.8974 13.4373 79.181 13.4103C79.49 13.3779 79.8004 13.3612 80.111 13.3603C81.0706 13.354 82.0209 13.5481 82.901 13.9303C83.7554 14.2977 84.5325 14.8236 85.191 15.4803C85.8446 16.1414 86.3701 16.9178 86.741 17.7703C87.117 18.6507 87.3109 19.598 87.3109 20.5553C87.3109 21.5126 87.117 22.46 86.741 23.3403C86.0016 25.0659 84.6266 26.4409 82.901 27.1803C82.0207 27.5563 81.0733 27.7502 80.116 27.7502C79.1587 27.7502 78.2114 27.5563 77.331 27.1803C76.4772 26.8119 75.7003 26.2861 75.041 25.6303C74.3811 24.9745 73.8546 24.1968 73.491 23.3403C73.1088 22.4602 72.9147 21.5099 72.921 20.5503V0.320312L67.801 1.85031V20.5703C67.7903 22.2181 68.1135 23.8509 68.751 25.3703C69.377 26.8312 70.2726 28.1611 71.391 29.2903C72.5176 30.412 73.8481 31.308 75.311 31.9303C76.8338 32.5638 78.4668 32.8899 80.116 32.8899C81.7653 32.8899 83.3983 32.5638 84.921 31.9303C87.8722 30.6753 90.2206 28.3233 91.471 25.3703C92.1047 23.8494 92.431 22.218 92.431 20.5703C92.431 18.9226 92.1047 17.2912 91.471 15.7703C90.8522 14.3085 89.9557 12.9806 88.831 11.8603Z"
                fill="#D0A444"
              />
              <path
                id="Vector_12"
                d="M118.079 15.7713C116.833 12.8178 114.483 10.4677 111.529 9.2213C110.007 8.58783 108.374 8.26172 106.724 8.26172C105.075 8.26172 103.442 8.58783 101.919 9.2213C98.9609 10.4637 96.6063 12.8148 95.3594 15.7713C94.702 17.2863 94.3616 18.9198 94.3594 20.5713C94.3643 22.2096 94.7046 23.8295 95.3594 25.3313C95.9806 26.7918 96.8769 28.1192 97.9994 29.2413C99.1276 30.366 100.457 31.2683 101.919 31.9013C103.431 32.5693 105.067 32.9101 106.719 32.9013C107.222 32.8969 107.723 32.8534 108.219 32.7713L109.679 32.5513L108.489 27.5513L107.629 27.7013C107.326 27.7174 107.022 27.7174 106.719 27.7013C105.764 27.71 104.817 27.5193 103.939 27.1413C103.084 26.7753 102.307 26.2492 101.649 25.5913C100.99 24.9332 100.46 24.1562 100.089 23.3013C99.7118 22.4197 99.5179 21.4704 99.5194 20.5113C99.5156 19.5516 99.7019 18.6007 100.067 17.7133C100.433 16.826 100.971 16.0198 101.649 15.3413C102.304 14.6802 103.082 14.1536 103.939 13.7913C104.818 13.415 105.764 13.2209 106.719 13.2209C107.675 13.2209 108.621 13.415 109.499 13.7913C111.241 14.5259 112.624 15.916 113.349 17.6613C113.729 18.5629 113.92 19.533 113.909 20.5113V32.8313H119.039V20.5713C119.037 18.9198 118.697 17.2863 118.039 15.7713"
                fill="#D0A444"
              />
            </g>
            <defs>
              <clipPath id="clip0_172_1956">
                <rect width="119.03" height="50.5" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
const emit = defineEmits(["finished"]);
const show = ref(true);
const showText = ref(false);
const showShimmer = ref(false);
const startExit = ref(false);

onMounted(() => {
  // Logo animation runs automatically via CSS (0-1.7s)

  setTimeout(() => {
    startExit.value = true;
    setTimeout(() => {
      show.value = false;
      emit("finished");
    }, 800); // Wait for fade out
  }, 3500); // Close 1.8s after animation completes
});
</script>

<style scoped>
@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeSlideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes lineGrow {
  from {
    clip-path: inset(0 100% 0 0);
    opacity: 0;
  }
  to {
    clip-path: inset(0 0% 0 0);
    opacity: 1;
  }
}

@keyframes fadePop {
  0% {
    opacity: 0;
    transform: scale(0.85);
  }
  70% {
    transform: scale(1.04);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* tayba letters - staggered fade up */
#tayba-logo #Vector_8 {
  opacity: 0;
  animation: fadeSlideUp 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.1s forwards;
}

#tayba-logo #Vector_9 {
  opacity: 0;
  animation: fadeSlideUp 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.22s forwards;
}

#tayba-logo #Vector_10 {
  opacity: 0;
  animation: fadeSlideUp 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.34s forwards;
}

#tayba-logo #Vector_11 {
  opacity: 0;
  animation: fadeSlideUp 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.46s forwards;
}

#tayba-logo #Vector_12 {
  opacity: 0;
  animation: fadeSlideUp 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.58s forwards;
}

/* horizontal gold line - grows left to right */
#tayba-logo #Vector {
  opacity: 0;
  animation: lineGrow 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.75s forwards;
}

/* travel letters - staggered fade down */
#tayba-logo #Vector_6 {
  opacity: 0;
  animation: fadeSlideDown 0.4s cubic-bezier(0.22, 1, 0.36, 1) 0.9s forwards;
}

#tayba-logo #Vector_4 {
  opacity: 0;
  animation: fadeSlideDown 0.4s cubic-bezier(0.22, 1, 0.36, 1) 0.98s forwards;
}

#tayba-logo #Vector_2 {
  opacity: 0;
  animation: fadeSlideDown 0.4s cubic-bezier(0.22, 1, 0.36, 1) 1.06s forwards;
}

#tayba-logo #Vector_5 {
  opacity: 0;
  animation: fadeSlideDown 0.4s cubic-bezier(0.22, 1, 0.36, 1) 1.14s forwards;
}

#tayba-logo #Vector_3 {
  opacity: 0;
  animation: fadeSlideDown 0.4s cubic-bezier(0.22, 1, 0.36, 1) 1.22s forwards;
}

#tayba-logo #Vector_7 {
  opacity: 0;
  animation: fadeSlideDown 0.4s cubic-bezier(0.22, 1, 0.36, 1) 1.3s forwards;
}

.shimmer-container {
  overflow: hidden;
}

.shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(208, 164, 68, 0.4) 50%,
    transparent 100%
  );
  animation: shimmer-move 1.5s ease-in-out forwards;
}

@keyframes shimmer-move {
  0% {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

.fade-out-screen {
  animation: screen-exit 0.8s cubic-bezier(0.7, 0, 0.3, 1) forwards;
}

@keyframes screen-exit {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
    visibility: hidden;
  }
}
</style>
